import { useBrand } from './brand';

/**
 * Headings and empty-state lines on the shared customer pages that a brand with
 * its own voice may reword (ADR-0008). The defaults are the house wording every
 * brand gets unless its BrandConfig.copy says otherwise. Labels that are already
 * brand fields (markName, locksName, valueName) stay there.
 */
export const DEFAULT_COPY = {
  upcomingTitle: 'Upcoming tips',
  bestTipsToday: "Today's best free tips",
  bestTips: 'Best free tips',
  meetingsToday: "Today's meetings",
  meetings: 'Meetings',
  noMeetings: 'No meetings with analysis available for this date.',
  soFarToday: 'Today so far',
  soFar: 'On the day',
  trackRecord: 'Our track record',
  noTrackRecord: 'No results for this period yet.',
  tomorrowReady: 'Tips ready for tomorrow',
  tomorrowComingSoon: 'Tips coming soon for tomorrow',
  tipsComingSoon: 'Tips coming soon',
  moreTipsComingSoon: 'More tips coming soon',
  noTipsForDayYet: 'No tips for this day yet',
  tipsReleaseNote: "Tips are usually released the night before, so they're built on the latest weather and track conditions.",
  topSelections: 'Top selections',
  valueSelection: 'Value selection',
  backToMeetings: 'Back to all meetings',
  noTipsYet: 'This model has no analysis for this meeting yet. Try the other model, or check back closer to the first race.',
};

export type BrandCopy = typeof DEFAULT_COPY;
export type CopyKey = keyof BrandCopy;

/** The brand's wording, falling back to the house default key by key. */
export function useCopy(): BrandCopy {
  const brand = useBrand();
  return brand.copy ? { ...DEFAULT_COPY, ...brand.copy } : DEFAULT_COPY;
}
